import styled from 'styled-components';

import { layout } from '@prisjakt/ui-base';
import Clickable from '@prisjakt/ui-clickable';

export const MenuItem = styled(Clickable)`
  white-space: nowrap;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${layout.spacing.xSmall} ${layout.spacing.small};
  color: ${p => p.theme.text.primary};
  background: ${p => p.theme.bg.primary};
  transition: background ${layout.animations.buttonTransition};
  cursor: pointer;

  &:hover {
    background: ${p => p.theme.bg.secondary};
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${p => p.theme.lines.secondary};
  }
`;

export const IconWrapper = styled.span`
  margin-left: auto;
  display: flex;
  align-items: center;
`;
